<template>
  <div class="row">
    <div class="col-md-2">&nbsp;</div>
    <div class="card col-md-8">
      <div class="card-body">
        <form class="px-4 py-3" @submit.prevent="submitSpecialCategory()">
          <!-- <label
            v-if="(categoryId <= 0 || isNaN(categoryId)) && !eloadCategoryModule.access.create"
            class="form-label medium fw-bold text-danger mb-3"
            >Note: Your access is limited. You cannot create a promo.</label
          >
          <label v-else-if="categoryId > 0 && !eloadCategoryModule.access.update" class="form-label medium fw-bold text-danger mb-3"
            >Note: Your access is limited. You cannot update a promo.</label
          > -->

          <div class="row">
            <div class="d-flex align-items-center col-md-8">
              <toggle-button :height="20" :width="40" v-model="category.status" color="#e73092" :sync="true"
                class="me-2" />
              <label class="form-label">Activate</label>
            </div>
            <div class="col-md-8 mb-3">
              <label class="form-label">Special Category Name<span style="color: red">*</span></label>
              <input type="text" class="form-control" v-model="category.name" placeholder="Enter Category Name"
                @change="submitted = false" :class="{
                  'is-invalid': submitted && category.name == '',
                }" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label">Hierarchy<span style="color: red">*</span></label>
              <input type="number" min="1" class="form-control" v-model="category.hierarchy"
                placeholder="Enter hierarchy" @change="submitted = false" :class="{
                  'is-invalid': submitted && category.hierarchy == '',
                }" />
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <label class="form-label">
                Alter Icon 1
                <span class="text-muted">(default) </span>
                <span class="text-danger">* </span>
                <b-link href="#" class="text-decoration-underline small" @click="viewIcon(1, icon1.url)">view icon</b-link>
              </label>
              <div class="form-check d-flex align-items-center">
                <input 
                  class="form-check-input custom-radio me-2" 
                  type="radio" 
                  id="iconRadio" 
                  name="iconRadio"
                  :checked="icon1.default"
                  @click="setDefaultIcon(1)" />
                <b-img
                  v-if="icon1.url"
                  :src="icon1.url"
                  class="custom-icon">
                </b-img>
              </div>
            </div>
            <div class="col-6">
              <label class="form-label">
                Alter Icon 2
                <span class="text-danger">* </span>
                <b-link v-if="icon2.url" href="#" class="text-decoration-underline small" @click="viewIcon(2, icon2.url)">view icon</b-link>
              </label>
              <div class="form-check d-flex align-items-center">
                <input 
                  class="form-check-input custom-radio me-2" 
                  type="radio" 
                  id="iconRadio" 
                  name="iconRadio"
                  :checked="icon2.default"
                  @click="setDefaultIcon(2)" />
                <div @click="triggerFileInput" v-if="icon2.url">
                  <input
                    style="display: none"
                    class="form-control mb-1"
                    :class="{
                      'is-invalid': submitted && icon2.default && icon2.url == '',
                    }"
                    type="file"
                    accept=".svg"
                    ref="fileInput"
                    @change="onFileChange"
                  />
                  <b-img
                    v-b-tooltip.hover.right="'Click to change icon 2'"
                    id="icon2-img-el"
                    :src="icon2.url"
                    class="custom-icon me-2">
                  </b-img>
                </div>
                <b-form-file v-else
                  style="width: 250px;"
                  class="form-control mb-1"
                  type="file"
                  accept=".svg"
                  v-model="iconFile"
                  @change="onFileChange"
                  plain
                />
              </div>
              <label class="small text-danger mb-0" v-if="submitted && icon2.default && icon2.url == ''">Icon 2 is required if it's set to default</label>
              <label class="small text-muted">File Format: Must be in SVG format.</label>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <label class="form-label">
                Alter Color 1
                <span class="text-danger">* </span>
              </label>
              <div class="form-check d-flex align-items-center">
                <input 
                  class="form-check-input custom-radio me-2" 
                  type="radio" 
                  id="colorRadio" 
                  name="colorRadio"
                  :checked="color1.default"
                  @click="setDefaultColor(1)" />
                  <v-input-colorpicker v-model="color1.value" />
              </div>
            </div>
            <div class="col-6">
              <label class="form-label">
                Alter Color 2
                <span class="text-danger">* </span>
              </label>
              <div class="form-check d-flex align-items-center">
                <input 
                  class="form-check-input custom-radio me-2" 
                  type="radio" 
                  id="colorRadio" 
                  name="colorRadio"
                  :checked="color2.default"
                  @click="setDefaultColor(2)" />
                  <v-input-colorpicker v-model="color2.value" />
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-6 mt-3">
              <b-button variant="primary" class="w-sm w-100p" type="submit">Save</b-button>
            </div>
            <div class="col-md-6 mt-3">
              <router-link :to="{ name: 'E-Load Special Category', params: {} }" class="tc-white">
                <b-button variant="light" class="w-sm w-100p" type="button">Cancel</b-button>
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { layoutMethods, digitalLoadMethods, digitalLoadComputed } from "@/state/helpers";
import { ToggleButton } from "vue-js-toggle-button";
import Swal from "sweetalert2";
import shortid from "shortid";
import InputColorPicker from 'vue-native-color-picker'

export default {
  page: {
    title: "Kankolek Adjustment Transaction Dashboard",
  },
  data() {
    return {
      category: {
        id: 0,
        name: "",
        hierarchy: "",
        status: true,
        icon: [],
        color: [],
      },
      submitted: false,
      iconFile: null,
      icon2Img: {
        filename: null,
        type: null,
        base64: null,
      },
      iconToChange: "",
      icon1: {
        name: "icon1",
        url: "https://dev-crm-files.peddlr.io/eload-special-category/icons/default-icon.svg",
        default: true
      },
      icon2: {
        name: "icon2",
        url: "",
        default: false
      },
      color1: {
        name: "color1",
        value: "#E83092",
        default: true
      },
      color2: {
        name: "color2",
        value: "#7F4697",
        default: false
      },
      s3_url: "",
      isForUploading: false,
      proceedAction: false,
    };
  },
  components: {
    ToggleButton,
    "v-input-colorpicker": InputColorPicker
  },
  computed: {
    ...digitalLoadComputed,
  },
  methods: {
    ...layoutMethods,
    ...digitalLoadMethods,
    async submitSpecialCategory() {
      this.submitted = true;
      if (this.submitted && (this.category.name == "" || (this.category.hierarchy == "" || this.category.hierarchy == 0) || (this.icon2.default && this.icon2.url == ""))) {
        return;
      }

      let action = this.category.id == 0 ? "create" : "update";
      let isIconUploaded = true

      if (this.isForUploading && this.icon2.default && this.icon2.url) {
        isIconUploaded = await this.uploadFile()
        if (isIconUploaded)
          this.icon2.url = this.s3_url
      }

      if (isIconUploaded) {
        let payload = {
          id: this.category.id,
          name: this.category.name,
          hierarchy: this.category.hierarchy,
          status: this.category.status ? 1 : 0,
          icon: [this.icon1, this.icon2],
          color: [this.color1, this.color2],
          proceedAction: this.proceedAction
        }

        await this.actionSpecialCategory({
          action: action,
          ...payload,
        })
          .then(() => {
            Swal.fire(
              `Successfully ${action == "create" ? "Created" : "Updated"}!`,
              `${this.category.name} has been ${action == "create" ? "created" : "updated"}.`,
              "success"
            );
            this.$router.push(
              this.$route.query.redirectFrom || {
                name: "E-Load Special Category",
              }
            );
          })
          .catch((res) => {
            let title = `${action == "create" ? "Create" : "Update"} Failed!`,
                message = res.data.message,
                icon = "error";

            if (res.status == 409) {
              title = `Hierarchy #${this.category.hierarchy} Already Exist`
              message = `By proceeding, the existing hierarchy (#${this.category.hierarchy}) will be changed into hierarchy (#${parseInt(this.category.hierarchy) + 1})`
              icon = "warning"
              Swal.fire({
                icon: icon,
                title: title,
                text: message,
                showCancelButton: true,
                confirmButtonText: "Proceed",
                cancelButtonText: "Cancel",
                buttonsStyling: false,
                customClass: {
                  actions: 'd-flex flex-column w-100',
                  confirmButton: 'btn btn-secondary mb-2 w-50',
                  cancelButton: 'btn btn-outline-secondary w-50'
                }
              })
              .then((res) => {
                if (res.isConfirmed) {
                  this.proceedAction = true
                  this.submitSpecialCategory()
                }
              });
            } else {
              Swal.fire(title, message, icon);
            }
          });
      } else {
        Swal.fire("Icon Not Uploaded!", "Error occured while uploading icon 2. Please try again later.", "error");
      }

      this.isForUploading = false
    },

    setDefaultIcon(iconNum) {
      switch (iconNum) {
        case 1:
          this.icon1.default = true;
          this.icon2.default = false;
          break;
        case 2:
          this.icon1.default = false;
          this.icon2.default = true;
          break;
      }
    },
    
    setDefaultColor(colorNum) {
      switch (colorNum) {
        case 1:
          this.color1.default = true;
          this.color2.default = false;
          break;
        case 2:
          this.color1.default = false;
          this.color2.default = true;
          break;
      }
    },

    viewIcon(iconNumber, iconUrl) {
      Swal.fire({
        title: iconNumber == 1 ? "<p>Icon 1 <span class='text-muted'>(default)</span></p> " : "Icon 2",
        html: `<img src=${iconUrl} height='200' width='200'>`,
        width: 300,
        showConfirmButton: false,
      });
    },

    onFileChange(e) {
      const reader = new FileReader();
      var files = e.target.files || e.dataTransfer.files;


      if (!files.length) {
        this.icon2Img = {
          filename: null,
          type: null,
          base64: null,
        };
        return;
      }

      reader.onloadend = () => {
        var base64Data = reader.result;
        this.icon2Img.base64 = new Buffer.from(base64Data.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""), "base64");
        this.icon2Img.type = base64Data.split(";")[0].split("/")[1];
        this.icon2Img.filename = `${shortid.generate()}.${this.icon2Img.type.replace("+xml","")}`;
        this.icon2.url = base64Data;
        this.isForUploading = true
        if (this.compareStr(this.icon2Img.type, ["svg+xml"]) === false) {
          this.icon2Img = {
            filename: null,
            type: null,
            base64: null,
          };
          this.isForUploading = false
          Swal.fire("Invalid supporting document!", `svg is required`, "error");
        }
      };
      reader.readAsDataURL(files[0]);
    },

    compareStr(data, arr_similar) {
      // case insensitive string comparison
      for (var i = 0; i < arr_similar.length; i++) {
        var areEqual = data.toUpperCase() === arr_similar[i].toUpperCase();
        if (areEqual) {
          return areEqual;
        }
      }
      return false;
    },

    async uploadFile() {
      let isUploaded = false;
      if (this.icon2Img.base64) {
        var icon2Img = { ...this.icon2Img };
        await this.uploadSpecialCategoryIcon2(icon2Img)
          .then((imageKey) => {
            this.s3_url = imageKey;
            isUploaded = true;
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } 

      return isUploaded;
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },
  },
  async mounted() {
    this.category.id = this.$route.params.id;
    this.changeTitle({ title: "Special Category Form" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Digital Load", to: { name: "" } },
        { text: "Category Promo", to: { name: "" } },
        { text: "Special Category Promo Form", to: { name: "" } },
      ],
    });

    if (this.category.id > 0) {
      await this.getLoadSpecialCategoryDetails({ id: this.category.id }).then(async () => {
        this.category.name = this.loadSpecialCategoryDetails.special_category_name;
        this.category.status = this.loadSpecialCategoryDetails.status == 1 ? true : false;
        this.category.hierarchy = this.loadSpecialCategoryDetails.hierarchy;
        this.icon1 = JSON.parse(JSON.stringify(this.loadSpecialCategoryDetails.icon[0]))
        this.icon2 = JSON.parse(JSON.stringify(this.loadSpecialCategoryDetails.icon[1]))
        this.color1 = JSON.parse(JSON.stringify(this.loadSpecialCategoryDetails.color[0]))
        this.color2 = JSON.parse(JSON.stringify(this.loadSpecialCategoryDetails.color[1]))
      });
    }
  },
};
</script>

<style scoped>
.custom-icon {
  height: 50px;
  width: 50px;
}
.form-check-input:checked {
    background-color: #E83092;
    border-color: #E83092;
}

.custom-radio {
  height: 23px;
  width: 23px;
}

</style>
